/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { AIGeneralBlockCard } from '../../AIGeneralBlockCard';
import { Text } from '../../../atoms/Text/Text';
import './CitationRendererStyles.scss';
const baseClass = 'qmb-ui-CitationRenderer';
const OBLIGATION_VARIANT = {
    shall: 'danger',
    should: 'warning',
    may: 'default'
};
export function CitationRenderer({ block }) {
    const citation = block;
    const sections = citation.citations.map((entry, i) => ({
        label: `${entry.standard} ${entry.edition_year} - ${entry.section}`,
        content: (React.createElement("div", { key: i, className: baseClass },
            React.createElement(Text, { variant: "body", className: `${baseClass}__title` }, entry.section_title),
            React.createElement(Text, { variant: "body" }, entry.content),
            React.createElement("span", { className: `${baseClass}__obligation ${baseClass}__obligation--${OBLIGATION_VARIANT[entry.obligation] || 'default'}` }, entry.obligation.toUpperCase()))),
        copyText: `${entry.standard} ${entry.section}: ${entry.content}`
    }));
    return React.createElement(AIGeneralBlockCard, { sections: sections });
}
